import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import BaseModal from "./BaseModal";
import Grid from "@mui/material/Grid";
import { Alert } from "@mui/material";
import { TextInputContainer } from "../forms/TextInput";
import { MenuItem } from "../../../node_modules/@mui/material/index";
import useGetSessionType from "constants/sessionType";

export default function EditSessionTypeAndClusterModal({ open, onClose, onSubmit, infoMessage, warningMessage, customField = [] }) {

    const { t } = useTranslation();
    let [sessionTypeVal, setSessionTypeVal] = useState();
    let [customFieldVal, setCustomFieldVal] = useState();
    let [error, setError] = useState({});
    const sessionType = useGetSessionType()

    function submit() {
        if (sessionTypeVal == null || sessionTypeVal == undefined) {
            setError({ sessionTypeVal: t('mandatoryField') })
            return
        }
        if (customFieldVal == null || customFieldVal == undefined) {
            setError({ customFieldVal: t('mandatoryField') })
            return
        }
        onSubmit(sessionTypeVal + " - " + customFieldVal);
        setError({});
        setSessionTypeVal(null)
        setCustomFieldVal(null)
        onClose();
    }

    return <BaseModal open={open} onClose={onClose} onSave={submit}>
        {infoMessage &&
            <Grid item xs={12} style={{ marginBottom: "0.5rem", padding: "16px" }}>
                <Alert variant="outlined" severity="info">{infoMessage}</Alert>
            </Grid>
        }
        {warningMessage &&
            <Grid item xs={12} style={{ marginBottom: "0.5rem", padding: "16px" }}>
                <Alert variant="outlined" severity="warning">{warningMessage}</Alert>
            </Grid>
        }
        <Grid container spacing={4} style={{ margin: 0, width: "100%", marginBottom: "1rem" }}>

            <TextInputContainer xs={6} required label={t('sessionType')} value={sessionTypeVal}
                options={sessionType} select
                onTextChange={(value) => setSessionTypeVal(value)}
                error={error.sessionTypeVal}>
                {sessionType.map(o => <MenuItem key={o.id} value={o.id}>{o.name}</MenuItem>)}
            </TextInputContainer>

            <TextInputContainer xs={6} required label={t('customField')} value={customFieldVal}
                options={customField} select
                onTextChange={(value) => setCustomFieldVal(value)}
                error={error.customFieldVal}>
                {customField.map(o => <MenuItem key={o.id} value={o.id}>{o.name}</MenuItem>)}
            </TextInputContainer>

            <div style={{ width: "15rem" }} />
        </Grid>
    </BaseModal>
}